export const QUOTATION_CREATION = 'quotation-creation';
export const QUOTATION_REQUEST = 'quotation-request';
export const QUOTATION_REJECT = 'quotation-reject';
export const CUSTOMER_MESSAGE = 'customer-message';
export const USER_MESSAGE = 'user-message';
export const QUOTATION_SUBMIT = 'quotation-submit';
export const WIP = 'wip';
export const QUOTATION_CANCELLATION = 'quotation-cancellation';
export const QUOTATION_ARCHIVING = 'archiving';
export const QUOTATION_ACCEPTATION = 'quotation-acceptation';
export const QUOTATION_UPDATED = 'updated';
export const UPDATE_CANCELLED_BY_CUSTOMER = "update-cancelled";
export const RESERVATION_CREATION = 'reservation-creation';
export const RESERVATION_CHANGE = 'reservation-change';
export const RESERVATION_ADD_REFUND = 'reservation-add-refund';
export const RESERVATION_ADD_PAYMENT = 'reservation-add-payment';
export const RESERVATION_TERMINATE = 'reservation-terminate';
export const RESERVATION_CANCEL = 'reservation-cancel';
